import { Feature, useGetFeatureToggles } from '@urbanx/agx.agencies.client';
import { AgxButton, AgxTypography } from '@urbanx/agx.ui-components2';
import { useNavigate } from 'react-router-dom';

export const NewProposalButton = () => {
  const { data, isPending, isError } = useGetFeatureToggles();
  const navigate = useNavigate();

  if (isPending) return null;
  if (isError || !data)
    return (
      <AgxTypography id="proposal-availability-error" type="body" size="medium" role="alert">
        Unable to load proposal availability.
      </AgxTypography>
    );
  if (!data.enabledFeatures?.includes(Feature.Proposals)) return null;

  return (
    <AgxButton
      id="new-proposal"
      dataTestId="new-proposal"
      text="New Proposal"
      variant="primary"
      size="large"
      onClick={() => navigate('/proposals/create')}
    />
  );
};
